import { render, staticRenderFns } from "./TranslationUploadBatchEdit.vue?vue&type=template&id=264e07d2"
import script from "./TranslationUploadBatchEdit.vue?vue&type=script&lang=js"
export * from "./TranslationUploadBatchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports